<template>
  <div class="complaintlList">
    <!-- 返回导航栏 -->
    <div class="wrapper-box">
      <div v-for="(lists,index) in compliantList" :key="index" @click="gocompliantDetail(lists)">
      <div class="items-box" >
        <div class="info-box">
          <div class="title">{{lists.complain_problem}}</div>
          <div class="dates">{{lists.complain_time.substring(0,10)}}</div>
          <div class="types">{{lists.complain_classify}}</div>
        </div>
        <div class="lookmore">
          <div class="texts">{{lists.subStatue}}</div>
          <img src="../../assets/travelAgency/ic_righticon.png" alt class="right-icon" />
        </div>
      </div>
      <rline  v-if="index < compliantList.length - 1"></rline>
      </div>
    </div>
  </div>
</template>
<script>
    import api from '../../service/modules/travel';
    import rline from './components/line';
    export default {
        components: {
            rline
        },

        data () {
            return {
                compliantList: []
            };
        },

        computed: {},

        watch: {},

        methods: {
            // 跳转投诉详情页
            gocompliantDetail (item) {
                this.$store.commit('complaint/setHandleWorkbench', false);
                console.log(`${this.globalApp.getSystemInfo().host}web/#/complaint/detailList/complaintSheet`)
                console.log('111')
                console.log(item)
                localStorage.setItem('item', JSON.stringify(item))
                console.log('222')
                console.log(localStorage.loadGuideData)
                setTimeout(() => {
                    window.yyn.invokeJSB(
                        'openWindow', {
                            openUrl: `${this.globalApp.getSystemInfo().host}web/#/complaint/detailList/complaintSheet`,
                            isFullScreen: 0,
                            setTitle: '',
                            needLoading: 1
                        },
                        cb => {
                            console.log(cb, 'callback');
                        }
                    );
                }, 300)
            },
            // 投诉列表
            getComplaintList () {
                api
                    .getComplaintList({
                        p: 1,
                        pageSize: 20,
                        name: JSON.parse(localStorage.travelDetail).travelAgencyDetails.name
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            this.compliantList = res.data.list;
                        }
                    });
            }
        },

        mounted () {
            this.getComplaintList();
        },
        created () {}
    };
</script>
<style scoped lang="less">
.complaintlList {
  width: 100%;
  height: 100%;
  background: rgba(251, 251, 251, 1);
  .wrapper-box {
    box-sizing: border-box;
    padding: 0 12px;
    background: #fff;

    .items-box {
      box-sizing: border-box;
      padding: 16px 0;
      display: flex;
      align-items: flex-end;
      background: #fff;

      .info-box {
        flex: 1;

        .title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 14px;
          margin-bottom: 12px;
        }
        .dates {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 12px;
          margin-bottom: 4px;
        }
        .types {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 12px;
        }
      }
      .lookmore {
        height: 16px;
        display: flex;
        align-items: center;
        overflow: hidden;
        .texts {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(54, 179, 116, 1);
          line-height: 12px;
          margin-right: 4px;
        }
        .right-icon {
          width: 12px;
          height: 12px;
          margin-top: 2px;
        }
      }
    }
  }
}
</style>
